module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Text-width-51f9f8806170a47e2cae09fa340c01ca.svg";